<template>
  <div>
    Display Failed Logins Here...
  </div>
</template>

<script>
export default {
  name: 'FailedLogins',
  data: function () {
    return {
    }
  },
  computed: {
  },
  methods: { },
}
</script>

<style lang="scss" scoped>
</style>
